import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue';
import slugify from 'slugify';

import {
  NkStack,
  NkText,
} from '@/core/components';

import { useGetTypeQuery } from '@/entities/type/hooks';
import { StDeviceCard } from './device-card.styled';
import { props as propsDefinition } from './device-card.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkDeviceCard',
  props: propsDefinition,
  setup(__props) {

const props = __props



const queryTypeParams = computed(() => ({
  id: props.type,
}));

const { data: type, isLoading } = useGetTypeQuery(queryTypeParams);
const getSlug = (value: string) => slugify(value, { lower: true });

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(StDeviceCard), _mergeProps({ class: "device-card" }, _ctx.$props), {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(NkStack), {
        align: 'center',
        as: "div",
        spacing: 6
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "device-card__svg device-svg-coloration",
            "data-svg-index": "0",
            "data-svg-name": 'foo',
            innerHTML: _unref(type)?.svg
          }, null, 8, _hoisted_1),
          _createVNode(_unref(NkText), {
            uppercase: true,
            type: "bold",
            class: "device-card__content"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(type)?.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })), [
        [_directive_loading, _unref(isLoading)]
      ])
    ]),
    _: 1
  }, 16))
}
}

})